function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftPos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.67,
    height: 12,
    viewBox: "0 0 11.67 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178016"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29503",
    d: "M.923 0A.923.923 0 0 0 0 .923v.923a.923.923 0 0 0 .923.923h10.154A.923.923 0 0 0 12 1.846V.923A.923.923 0 0 0 11.077 0H.923z",
    transform: "rotate(90 1.385 1.385)",
    style: {
      fill: "#66676b",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29504",
    d: "M7.568 4.932a.45.45 0 0 0-.636.636L8.414 7.05H2.5a.45.45 0 0 0 0 .9h5.914L6.932 9.432a.45.45 0 0 0 .636.636l2.25-2.25a.45.45 0 0 0 0-.636z",
    transform: "translate(1.72 -1.5)",
    style: {
      fill: "#66676b",
      fillRule: "evenodd"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftPos);
export default __webpack_public_path__ + "static/media/leftPos.4f40ac9acd9f10012490a718dc287e17.svg";
export { ForwardRef as ReactComponent };